import { render, staticRenderFns } from "./TrxR_Result.vue?vue&type=template&id=c10e70ec"
import script from "./TrxR_Result.vue?vue&type=script&lang=js"
export * from "./TrxR_Result.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports